import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence } from 'framer-motion';
import Text from '../../../../../General/Text';
import Button from '../../../../../General/Button';
import {
  AltPriceTextStyled,
  BalanceDividerStyled,
  BalanceStyled,
  ContainerStyled,
  ContentStyled,
  HandleStyled,
  HeaderStyled,
  IsRecurringWarningStyled,
  PricesDetailsStyled,
  TextStyled,
} from './style/MethodStyled';
import { ReactComponent as ArrowNavIcon } from '../../../../../../images/ui/arrow-nav.svg';
import { ReactComponent as AlertIcon } from '../../../../../../images/ui/alert-icon.svg';
import { Numbers } from '../../../../../../helpers';
import useOtherLines from '../../../../../../hooks/useOtherLines';
import { LoadingButton } from '../../../../../OtherLines/OtherLinesSidePanel/styles/OtherLinesSidePanelStyles';
import ButtonLoading from '../../../../../General/ButtonLoading';

const AgainstBalanceMethod = ({
  balance,
  bundlePrice,
  buyCallback,
  isRecurring,
}) => {
  const [toggled, setToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const clickHandler = () => {
    setToggle(!toggled);
  };
  const { isOtherLines, setPaymentType } = useOtherLines();
  const buyHandler = () => {
    if (!isOtherLines) {
      buyCallback('CONTRASALDO');
      setIsLoading(true);
    } else {
      setPaymentType('saldo');
      buyCallback('CONTRAFACTURA-OTRAS-LINEAS');
      setIsLoading(true);
    }
  };
  const rechargeHandler = () => {
    buyCallback('RECARGAR');
    setIsLoading(true);
  };

  const price = Number(bundlePrice);
  return (
    <ContainerStyled>
      <HeaderStyled>
        <TextStyled>
          <Text
            text={balance < price ? 'Recargar' : 'Descontar de tu saldo'}
            color="#381451"
            size="18px"
            weight="500"
          />
          <BalanceStyled>
            Saldo actual:
            <span>{` $${Numbers.addThousandSeparators(balance)}`}</span>
          </BalanceStyled>
        </TextStyled>
        <HandleStyled
          data-testid="toggle-handler"
          toggled={toggled}
          onClick={clickHandler}
        >
          <ArrowNavIcon />
        </HandleStyled>
      </HeaderStyled>
      <AnimatePresence initial={false}>
        {toggled && (
          <ContentStyled
            data-testid="toggle-content"
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.3 }}
          >
            {balance < price ? (
              <>
                <PricesDetailsStyled data-testid="recharge-warning">
                  <AltPriceTextStyled>
                    Necesitas agregar
                    <span>
                      {` $${Numbers.addThousandSeparators(price - balance)} `}
                    </span>
                    a tu saldo
                  </AltPriceTextStyled>
                </PricesDetailsStyled>
                <Button
                  color="bubbleGum"
                  maxWidth="100%"
                  click={rechargeHandler}
                >
                  RECARGAR
                </Button>
              </>
            ) : (
              <>
                <PricesDetailsStyled>
                  <div>
                    <Text
                      text="Tienes"
                      color="#7c6c8a"
                      size="14px"
                      weight="400"
                    />
                    <Text
                      text={`$${Numbers.addThousandSeparators(balance)}`}
                      color="#2d1441"
                      size="17px"
                      weight="600"
                    />
                  </div>
                  <BalanceDividerStyled />
                  <div>
                    <Text
                      text="Usaras"
                      color="#e9226f"
                      size="14px"
                      weight="400"
                    />
                    <Text
                      text={`$${Numbers.addThousandSeparators(price)}`}
                      color="#e9226f"
                      size="17px"
                      weight="600"
                    />
                  </div>
                  <BalanceDividerStyled />
                  <div>
                    <Text
                      text="Te quedará"
                      color="#7c6c8a"
                      size="14px"
                      weight="400"
                    />
                    <Text
                      text={`$${Numbers.addThousandSeparators(
                        balance - price
                      )}`}
                      color="#2d1441"
                      size="17px"
                      weight="600"
                    />
                  </div>
                </PricesDetailsStyled>

                {isLoading ? (
                  <LoadingButton>
                    <ButtonLoading />
                  </LoadingButton>
                ) : (
                  <Button color="bubbleGum" maxWidth="100%" click={buyHandler}>
                    {`${isRecurring ? 'PAGAR' : 'COMPRAR'}`}
                  </Button>
                )}

                {isRecurring && (
                  <IsRecurringWarningStyled>
                    <AlertIcon />
                    <div data-testid="isrecurring-warning">
                      Recuerda que el Plan Recurrente tiene pago automático por
                      lo que necesitas contar con saldo, te lo recordaremos más
                      adelante.
                    </div>
                  </IsRecurringWarningStyled>
                )}
              </>
            )}
          </ContentStyled>
        )}
      </AnimatePresence>
    </ContainerStyled>
  );
};

AgainstBalanceMethod.propTypes = {
  balance: PropTypes.number.isRequired,
  bundlePrice: PropTypes.string.isRequired,
  buyCallback: PropTypes.func.isRequired,
  isRecurring: PropTypes.bool,
};

AgainstBalanceMethod.defaultProps = {
  isRecurring: false,
};

export default AgainstBalanceMethod;
